/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";

import { CheckIcon } from "./components/CheckIcon";
import { inputStyle, rootStyle, squareStyle } from "./styles";

import type { InputHTMLAttributes } from "react";
import type { FcWithoutChildren } from "types/fcWithoutChildren";

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, "type">;

export const Checkbox: FcWithoutChildren<Props> = (props) => {
  return (
    <span css={rootStyle}>
      <input css={inputStyle} {...props} type="checkbox" />
      <span css={squareStyle} />
      <CheckIcon height={10} width={14} />
    </span>
  );
};
